import { Sport } from '@/constants';
import type { IFilterWithMetadata } from '@/types/bet';

export const SPORT_FILTER_TITLE = 'customLeagues.sport';

export function createRequiredSportFilter(): IFilterWithMetadata<number | null> {
    return {
        value: Sport.Football,
        title: SPORT_FILTER_TITLE,
        allowSaveState: true,
        disableClear: true,
    };
}

export function createOptionalSportFilter(): IFilterWithMetadata<number | null> {
    return {
        value: null,
        title: SPORT_FILTER_TITLE,
        allowSaveState: true,
    };
}

export function resetRequiredSportFilter(filter: IFilterWithMetadata<number | null>) {
    filter.value = Sport.Football;
}

export function resetOptionalSportFilter(filter: IFilterWithMetadata<number | null>) {
    filter.value = null;
}
